import ContactForm from "./ContactForm";
import Map from "./Map";
import { toast } from "react-toastify";
import { toastError } from "../../utils/toastSafe";
import { MessageModel } from "../../service";
import { FormikHelpers } from "formik";
import { Fade } from "react-awesome-reveal";
import { FiPhone, FiMail, FiMapPin } from "react-icons/fi";
import {
  PHONE_MOBILE_DISPLAY,
  PHONE_OFFICE_DISPLAY,
  PHONE_MOBILE_HREF,
  PHONE_OFFICE_HREF,
} from "../../constants/contact";

type formValues = {
  name: string;
  email: string;
  phone: string;
  subject: string;
  message: string;
};

const ContactScreen = () => {
  const mapUrl =
    "https://www.google.com/maps?q=Unit%201502-%20239%20Queen%20St%20E%2C%20Brampton%2C%20ON%20L6W%202B6";
  const onFormSubmit = async (
    values: formValues,
    formikHelpers: FormikHelpers<formValues>
  ) => {
    try {
      let response = await MessageModel.registerMessage(values);
      if (response.status === 200) {
        toast.success("Message Submitted!");
        formikHelpers.resetForm();
      }
    } catch (error) {
      console.log(error);
      toastError("Something went wrong!");
    }
  };
  return (
    <section className="bg-neutral-900 px-6 py-16 lg:py-24">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-14">
          <div className="bg-neutral-800 shadow-md p-6 rounded-xl col-span-1 md:col-span-2 lg:col-span-1">
            <Fade delay={200} triggerOnce>
              <a href={PHONE_MOBILE_HREF} className="block mb-4">
                <FiPhone size={30} className="text-cred-100 mb-2" />
                <span className="block text-white/80 text-xs uppercase tracking-wide mb-1">
                  Mobile
                </span>
                <span className="block text-white">{PHONE_MOBILE_DISPLAY}</span>
              </a>
            </Fade>
            <Fade delay={300} triggerOnce>
              <a href={PHONE_OFFICE_HREF} className="block mb-4">
                <FiPhone size={30} className="text-cred-100 mb-2" />
                <span className="block text-white/80 text-xs uppercase tracking-wide mb-1">
                  Office
                </span>
                <span className="block text-white">{PHONE_OFFICE_DISPLAY}</span>
              </a>
            </Fade>
            <Fade delay={400} triggerOnce>
              <a href="mailto:info@alpham.ca" className="block mb-4">
                <FiMail size={30} className="text-cred-100 mb-2" />
                <span className="block text-white">info@alpham.ca</span>
              </a>
            </Fade>
            <Fade triggerOnce>
              <div className="">
                <FiMapPin size={30} className="text-cred-100 mb-2" />
                <a
                  href={mapUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="text-white underline-offset-4 hover:underline"
                >
                  Unit 1502- 239 Queen St E
                  <br />
                  Brampton, ON L6W 2B6
                </a>
              </div>
            </Fade>
          </div>
          <div className="col-span-1 md:col-span-2 lg:col-span-3">
            <Fade direction="up" triggerOnce>
              <div
                id="contact-form"
                className="bg-neutral-800 shadow-md p-6 rounded-xl"
              >
                <ContactForm onFormSubmit={onFormSubmit} />
              </div>
            </Fade>
          </div>
        </div>
        <Fade triggerOnce>
          <Map />
        </Fade>
      </div>
    </section>
  );
};

export default ContactScreen;
